<template>
  <div id="app" :class="{ 'pt-12': authStore.isMasquerading }">
    <MasqueradeBanner v-if="authStore.isMasquerading" />
    <Navigation />
    <router-view />
    <Footer />
    <ConfirmDialog />
    <CookieNotice />
  </div>
</template>

<script setup>
import Navigation from './components/Navigation.vue'
import Footer from './components/Footer.vue'
import ConfirmDialog from './components/ConfirmDialog.vue'
import CookieNotice from './components/CookieNotice.vue'
import MasqueradeBanner from './components/MasqueradeBanner.vue'
import { useAuthStore } from './stores/auth'

const authStore = useAuthStore()
</script>
